/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Rangiro 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Banda": ["Bururi", "Gahira", "Gasumo", "Nkamba", "Uwakagano"],
  "Gakenke": ["Gahisi", "Gasovu", "Kamatsira", "Ruhana", "Rwasa"],
  "Jurwe": ["Gasebeya", "Gatagara", "Kaneke", "Kibavu", "Rudehero", "Rugomero"],
  "Murambi": ["Bigeyo", "Bunyenyezi", "Munini", "Murambi", "Nyakabingo", "Nyarwungo", "Ryarubasha"]
};